export enum  RiskDistributionParameterType
  {
  RiskBand = 1,
  Pof = 2,
  Cof = 3
}
